import UserForm, { UserFormModeEnum } from "../../components/UserForm/UserForm";

export function ExternalRegister() {
  return <div className="m-4">
    <UserForm userFormMode={UserFormModeEnum.REGISTER} />
  </div>
}